<template>
  <div
    class="import-strategies-create"
    >
    <v-btn
      v-if="create"
      color="green"
      @click="createUObject({
          url: [
            {businesses: business.id},
            {bifcimportstrategies: ''},
            {showWithEntitiesNormalized: ''}
          ],
          u_object: new_strategy
        })"
      >
      create
    </v-btn>
    <v-btn
      v-else
      color="red"
      @click="deleteUObject({
          url: [
            {businesses: business.id},
            {bifcimportstrategies: strategy.id},
          ],
        })"
      >
      delete
    </v-btn>
    <div class="import-strategies-create-entry mt-6">
      <div>Name:</div>
      <input
        class="import-strategies-create-input-field"
        :value="strategy.name"
        @change="changeValue('name', $event.target.value)"
        />
    </div>
    <div class="import-strategies-create-entry">
      <div>Description:</div>
      <input
        class="import-strategies-create-input-field"
        :value="strategy.description"
        @change="changeValue('description', $event.target.value)"
        />
    </div>
    <!-- <div
      class="import-strategies-create-entry mt-6"
      >
      <h3>Element Custom Value Mapping:</h3>
      <RadialCheckbox
        class="ml-1"
        :is_checked="strategy.element_custom_value_mapping"
        @setActive="changeValue('element_custom_value_mapping', !strategy.element_custom_value_mapping)"
        />
    </div> -->
    <h3 class="ma-1 mt-6 mb-2">Element Custom Value Mapping</h3>
    <IFCImportStrategyMappingMatrixModule
      :strategy="strategy"
      @changeValue="changeValue($event.key, $event.value)"
      />
      <h3 class="ma-1 mt-6 mb-2">Taktarea Mapping</h3>
      <div
        class="import-strategies-create-entry"
        >
        <div class="import-strategies-create-prop-text">Taktarea Map:</div>
        <input
          class="import-strategies-create-input-field"
          :value="strategy[`taktarea_propertyset_name`]"
          @change="changeValue('taktarea_propertyset_name', $event.target.value)"
          />
        <input
          class="import-strategies-create-input-field"
          :value="strategy[`taktarea_property_name`]"
          @change="changeValue('taktarea_property_name', $event.target.value)"
          />
      </div>

      <!-- space import -->
      <h3 class="ma-1 mt-6 mb-2">Space Import</h3>
      <div v-for="type in ['floor', 'side', 'ceiling']" :key="type">
      <div
        class="import-strategies-create-entry"
        >
        <div>Create {{type[0].toUpperCase() + type.slice(1)}} Covering: </div>
        <RadialCheckbox
          class="ml-1"
          :is_checked="strategy[`space_create_${type}_covering`]"
          @setActive="changeValue(`space_create_${type}_covering`, !strategy[`space_create_${type}_covering`])"
          />
      </div>
      <div
        v-if="strategy[`space_create_${type}_covering`]"
        class="import-strategies-create-entry ml-12"
        >
        <div>{{type[0].toUpperCase() + type.slice(1)}} Custom Value Mapping (Propertysets from Space): </div>
        <RadialCheckbox
          class="ml-1"
          :is_checked="strategy[`space_${type}_mapping`]"
          @setActive="changeValue(`space_${type}_mapping`, !strategy[`space_${type}_mapping`])"
          />
      </div>
      <IFCImportStrategyMappingMatrixModule
        class="ml-11"
        v-if="strategy[`space_create_${type}_covering`] && strategy[`space_${type}_mapping`]"
        :strategy="strategy"
        :prefix="`space_${type}_covering_`"
        @changeValue="changeValue($event.key, $event.value)"
        />
        <div
          v-if="strategy[`space_create_${type}_covering`]"
          class="import-strategies-create-entry ml-12"
          >
          <div>Copy all Propertysets from Space to {{type[0].toUpperCase() + type.slice(1)}} Element</div>
          <RadialCheckbox
            class="ml-1"
            :is_checked="strategy[`space_${type}_copy_property_sets`]"
            @setActive="changeValue(`space_${type}_copy_property_sets`, !strategy[`space_${type}_copy_property_sets`])"
            />
        </div>
    </div>

    <!-- element assemblys -->
    <h3 class="ma-1 mt-6 mb-2">Elementassembly Import</h3>
    <div
      class="import-strategies-create-entry"
      >
      <div>Convert Elementassembly into Element: </div>
      <RadialCheckbox
        class="ml-1"
        :is_checked="strategy.elementassemblys_as_elements"
        @setActive="changeValue('elementassemblys_as_elements', !strategy.elementassemblys_as_elements)"
        />
    </div>
    <div
      v-if="strategy.elementassemblys_as_elements"
      class="import-strategies-create-entry ml-12"
      >
      <div>Element Custom Value Mapping (Propertysets from Elementassembly): </div>
      <RadialCheckbox
        class="ml-1"
        :is_checked="strategy.elementassemblys_as_elements_mapping"
        @setActive="changeValue('elementassemblys_as_elements_mapping', !strategy.elementassemblys_as_elements_mapping)"
        />
    </div>
    <IFCImportStrategyMappingMatrixModule
      v-if="strategy.elementassemblys_as_elements && strategy.elementassemblys_as_elements_mapping"
      class="ml-12"
      :strategy="strategy"
      prefix="elementassemblys_as_elements_"
      @changeValue="changeValue($event.key, $event.value)"
    />
  </div>
</template>
<script>
  import { mapActions } from 'vuex';
  import IFCImportStrategyMappingMatrixModule from '@/modules/Company/IFCImportStrategyMappingMatrixModule.module.vue'
  import RadialCheckbox from '@/components/WorkPackageWIP/RadialCheckbox.component.vue'
  export default {
    props: ['create'],
    components: {
      IFCImportStrategyMappingMatrixModule,
      RadialCheckbox,
    },
    data: () => ({
      new_strategy: {
        name: '',
        description: '',
        element_custom_value_mapping: false,
        //taktarea
        taktarea_propertyset_name: '',
        taktarea_property_name: '',
        //space
        space_create_floor_covering: false,
        space_create_side_covering: false,
        space_create_ceiling_covering: false,
        space_floor_mapping: false,
        space_side_mapping: false,
        space_ceiling_mapping: false,
        space_floor_copy_property_sets: true,
        space_side_copy_property_sets: true,
        space_ceiling_copy_property_sets: true,
        //elementassemblies
        elementassemblys_as_elements: false,
        elementassemblys_as_elements_mapping: false,
      }
    }),
    created() {
      //mapping matrices for elements
      for (let prefix in ['', 'elementassemblys_as_elements_', 'space_floor_covering_', 'space_side_covering_', 'space_ceiling_covering_']) {
        Object.assign(this.new_strategy,
        {
          [`${prefix}length_property_name`]: '',
          [`${prefix}length_propertyset_name`]: '',
          [`${prefix}width_property_name`]: '',
          [`${prefix}width_propertyset_name`]: '',
          [`${prefix}height_property_name`]: '',
          [`${prefix}height_propertyset_name`]: '',
          [`${prefix}volume_property_name`]: '',
          [`${prefix}volume_propertyset_name`]: '',
          [`${prefix}perimeter_property_name`]: '',
          [`${prefix}perimeter_propertyset_name`]: '',
          [`${prefix}floor_area_property_name`]: '',
          [`${prefix}floor_area_propertyset_name`]: '',
          [`${prefix}surface_property_name`]: '',
          [`${prefix}surface_propertyset_name`]: '',
          [`${prefix}lateral_surface_property_name`]: '',
          [`${prefix}lateral_surface_propertyset_name`]: '',
          [`${prefix}weight_property_name`]: '',
          [`${prefix}weight_propertyset_name`]: '',
          [`${prefix}side_area_property_name`]: '',
          [`${prefix}side_area_propertyset_name`]: '',
        });
      }
    },
    computed: {
      business() {
        let current_user = this.$store.getters['Auth/getUser'];
        return this.$store.state.Ultra.businesses[current_user.business.id];
      },
      strategy() {
        if (this.create) {
          return this.new_strategy;
        } else {
          return this.$store.state.Ultra.bifcimportstrategies[this.$route.params.strategy_id];
        }
      }
    },
    methods: {
      ...mapActions('Ultra', [
        'createUObject',
        'updateUObject',
        'deleteUObject'
      ]),
      changeValue(key, value) {
        if (this.create) {
          this.strategy[key] = value;
        } else {
          this.updateUObject({
            url: [
              {businesses: this.business.id},
              {bifcimportstrategies: this.strategy.id},
            ],
            update: {
              [key]: value
            }
          });
        }
      }
    }
  }
</script>
<style>
  .import-strategies-create {
    position: relative;
    height: 100%;
    overflow: auto;
  }
  .import-strategies-create-entry {
    display: flex;
    margin: 5px;
    align-items: center;
  }
  .import-strategies-create-input-field {
    border: solid 1px white;
    margin-left: 15px;
    border-radius: 5px;
  }
  .import-strategies-create-prop-text {
    width: 125px;
  }
  .import-strategies-create-header {
    display: flex;
    width: 169px;
    margin-left: 15px;
    justify-content: center;
  }
</style>
